// eslint-disable-next-line no-undef
@Inject('gettextCatalog')
class MessageDefinitionService {
  constructor() {
    this.definitions = {
      SELF: {
        id: 'SELF',
        desc: this.gettextCatalog.getString('Self'),
      },
      ALL: {
        id: 'ALL',
        desc: this.gettextCatalog.getString('All'),
      },
      SENT: {
        id: 'SENT',
        desc: this.gettextCatalog.getString('Sent'),
      },
      SUBJECT_AND_PREVIEW: {
        id: 'SUBJECT_AND_PREVIEW',
        desc: this.gettextCatalog.getString('Subject & Preview'),
      },
      AUTHOR: {
        id: 'AUTHOR',
        desc: this.gettextCatalog.getString('Author'),
      },
      RECIPIENT: {
        id: 'RECIPIENT',
        desc: this.gettextCatalog.getString('Recipient'),
      },
      FROM: {
        id: 'FROM',
        desc: this.gettextCatalog.getString('From'),
      },
      DATE: {
        id: 'DATE',
        desc: this.gettextCatalog.getString('Date'),
      },
      USERNAME: {
        desc: this.gettextCatalog.getString('Username'),
      },
      READ_DATE: {
        desc: this.gettextCatalog.getString('Read date'),
      },
      READ_STATUS: {
        desc: this.gettextCatalog.getString('Read status'),
      },
      REPLIED_DATE: {
        desc: this.gettextCatalog.getString('Replied date'),
      },
      REPLIED_STATUS: {
        desc: this.gettextCatalog.getString('Replied status'),
      },
      NO_RECIPIENTS: {
        desc: this.gettextCatalog.getString('You must add at least one recipient'),
      },
      NO_RETAILER: {
        desc: this.gettextCatalog.getString('You must add at least one retailer number'),
      },
      MSG_SENT: {
        desc: this.gettextCatalog.getString('The message has been sent successfully.'),
      },
      MSG_DELETE: {
        desc: this.gettextCatalog.getString('The message has been successfully deleted.'),
      },
      MSGS_DELETE: {
        desc: this.gettextCatalog.getString('The selected messages have been successfully deleted.'),
      },
    };
  }

  get(key, property = null) {
    try {
      if (property) return this.definitions[key][property];

      return this.definitions[key];
    } catch (error) {
      console.log('CAN NOT FIND MESSAGE DEFINITION');
    }
  }
}

export default MessageDefinitionService;



// WEBPACK FOOTER //
// ./src/modules/message/message-definition-service.js